import React, { useMemo, useRef, useState } from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import { Select, Input, Modal, Button, Typography, Switch, Dropdown, Menu } from 'antd';
import queryString from 'query-string';
import { SearchOutlined, PoweroffOutlined, ArrowRightOutlined, ScheduleTwoTone, LoadingOutlined } from '@ant-design/icons';
import { useHistory } from 'react-router-dom';
import _ from 'lodash';
import { userInfoVar } from 'src/apollo/cache';
import { useQuery } from '@apollo/client';
import { EXTERNAL_USER_STUDY_LIST_LEVELUP } from 'src/operations/queries/externalStudy';
import LevelUpLibraryMenuGroup from 'src/components/common/LevelUpLibraryMenuGroup';
import LevelUpLibraryMobileHeader from 'src/components/common/LevelUpLibraryMobileHeader';
import moment from 'moment';
import * as axios from 'axios';
import BackButton from 'src/components/common/BackButton';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { classStoreData } from 'src/operations/store';
import { isMobileOnly } from 'react-device-detect';
import FullScreenButton from 'src/components/common/FullScreenButton';
import UseHistoryState from 'src/components/common/UseHistoryState';
import imageexcel from 'src/images/xlsicon.png';
import LeftMenu2 from 'src/components/LevelUp/LeftMenu/index2.js';
import LevelUpLibraryMenuGroup3 from 'src/components/common/LevelUpLibraryMenuGroup3';
import { GET_STUDENT_LUPUSER, GET_TEACHER_USER } from 'src/operations/queries/getUser';
const { Option } = Select;
const { Title, Text } = Typography;
// const { Search } = Input;
const RowFlex = styled.div`
  display: flex;
  flex-direction: row;
`;
const ColumnFlex = styled.div`
  display: flex;
  flex-direction: column;
`;
const Wrapper = styled.div`
  width: 100%;
  min-height: 100vh;
  height: 100vh;
  padding-top: ${({ $isMobile }) => ($isMobile ? '0' : '64px')};
  overflow: ${({ $isMobile }) => ($isMobile ? 'auto' : 'hidden')};
  box-sizing: border-box;
  background:
    radial-gradient(ellipse 800px 500px at 15% 30%, rgba(34, 211, 238, 0.08) 0%, transparent 70%),
    radial-gradient(ellipse 600px 400px at 85% 70%, rgba(16, 185, 129, 0.06) 0%, transparent 70%),
    radial-gradient(ellipse 500px 300px at 50% 10%, rgba(139, 92, 246, 0.04) 0%, transparent 70%),
    #e8f4f8;
`;
const MobileLevelDropdownStyle = createGlobalStyle`
  .levelup-portfolio-dd {
    .ant-dropdown-menu-item {
      padding-left: 10px !important;
    }
  }
`;
const Header = styled(RowFlex)`
  justify-content: start;
  align-items: center;
  height: 75px;
  padding: 16px 65px 16px 45px;
  background-color: #ffa700;
  background-image: url('/images/cloud.png');
  background-position: center bottom;
  background-repeat: no-repeat;
`;
const HeadBox = styled.div`
  height: 43px;
  line-height: 43px;
  font-size: 1.5em;
  font-weight: bolder;
  border-radius: 5px;
  background-color: ${(props) => (props.background ? props.background : '#fff')};
  color: ${(props) => props.color};
  padding: 0 20px;
  margin-right: 30px;
`;
const CloseButton = styled.div`
  cursor: pointer;
  border-radius: 50px;
  font-size: 1.3em;
  font-weight: bold;
  color: #fff;
  /* background: #ed7d31; */
  width: 43px;
  height: 43px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 10px;
`;
const MobileHeader = styled(RowFlex)`
  justify-content: space-between;
  align-items: center;
  height: 64px;
  padding: 0 12px;
  background-color: #ffa700;
  background-image: url('/images/cloud.png');
  background-position: center bottom;
  background-repeat: no-repeat;
`;
const MobileSpacer = styled.div`
  width: 34px;
  height: 34px;
`;
const MobileIconButton = styled.button`
  width: 34px;
  height: 34px;
  border-radius: 8px;
  border: none;
  background: rgba(255, 255, 255, 0.25);
  color: #6b4b32;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
`;
const MobileActions = styled(RowFlex)`
  gap: 8px;
  align-items: center;
`;
const PortfolioMobilePage = styled.div`
  width: 100%;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 32;
`;
const PortfolioMobileAppHeader = styled(RowFlex)`
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  padding: 12px 16px 14px;
  box-sizing: border-box;
  background: linear-gradient(135deg, #0c1a2e 0%, #1e3a5f 60%, #0891b2 100%);
  position: relative;
  z-index: 1;
  overflow: hidden;
  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background-image: radial-gradient(circle, rgba(255, 255, 255, 0.06) 1px, transparent 1px);
    background-size: 18px 18px;
    pointer-events: none;
  }
`;
const PortfolioMobileHeaderBrand = styled(RowFlex)`
  position: relative;
  z-index: 1;
  align-items: center;
  gap: 8px;
  min-width: 0;
  flex: 1;
`;
const PortfolioMobileHeaderLogo = styled.div`
  width: 36px;
  height: 36px;
  border-radius: 14px;
  background: linear-gradient(135deg, #0891b2, #06b6d4);
  background-image: url('/images/LevelUp/levelup_owl.png');
  background-position: center;
  background-repeat: no-repeat;
  background-size: 24px 24px;
  box-shadow: 0 4px 12px rgba(8, 145, 178, 0.4);
  flex-shrink: 0;
`;
const PortfolioMobileHeaderName = styled.div`
  font-family: 'Baloo 2', sans-serif;
  font-size: 18px;
  font-weight: 900;
  color: #ffffff;
  line-height: 1;
  span {
    color: #22d3ee;
  }
`;
const PortfolioMobileHeaderActions = styled(RowFlex)`
  position: relative;
  z-index: 1;
  gap: 8px;
  align-items: center;
`;
const PortfolioMobileHeaderRound = styled.button`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.12);
  border: 1.5px solid rgba(255, 255, 255, 0.2);
  color: #ffffff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  padding: 0;
`;
const PortfolioMobileInner = styled.div`
  padding: 0 12px 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
const PortfolioMobileTopCard = styled.div`
  border-radius: 24px;
  background: rgba(255, 255, 255, 0.92);
  border: 1.5px solid rgba(255, 255, 255, 0.75);
  box-shadow: 0 14px 30px rgba(8, 145, 178, 0.12);
  backdrop-filter: blur(10px);
  padding: 14px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;
const PortfolioMobileTitle = styled.div`
  font-family: 'Baloo 2', sans-serif;
  font-size: 24px;
  font-weight: 900;
  color: #0c1a2e;
`;
const PortfolioMobileSub = styled.div`
  font-size: 12px;
  font-weight: 700;
  color: #64748b;
`;
const PortfolioMobileStatRow = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
`;
const PortfolioMobileStatCard = styled.div`
  border-radius: 18px;
  background: linear-gradient(180deg, rgba(255,255,255,.96), rgba(232,244,248,.88));
  border: 1.5px solid rgba(8, 145, 178, 0.1);
  padding: 14px 16px;
`;
const PortfolioMobileStatValue = styled.div`
  font-family: 'Baloo 2', sans-serif;
  font-size: 28px;
  font-weight: 900;
  color: #0c1a2e;
  line-height: 1;
`;
const PortfolioMobileStatLabel = styled.div`
  margin-top: 6px;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: .08em;
  text-transform: uppercase;
  color: #94a3b8;
`;
const PortfolioMobileFilterCard = styled.div`
  border-radius: 24px;
  background: #ffffff;
  border: 1.5px solid rgba(8, 145, 178, 0.12);
  box-shadow: 0 2px 12px rgba(8, 145, 178, 0.12);
  padding: 12px 14px;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
const PortfolioMobileTabsShell = styled.div`
  position: fixed;
  top: ${(props) => (props.$searchOpen ? '108px' : '64px')};
  left: 0;
  right: 0;
  z-index: 18;
  background: #ffffff;
  padding: 0 12px 10px;
  box-shadow: 0 8px 20px rgba(8, 145, 178, 0.08);
`;
const PortfolioMobileTabsSpacer = styled.div`
  height: ${(props) => (props.$searchOpen ? '122px' : '78px')};
  flex-shrink: 0;
`;
const PortfolioMobileTabs = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 8px;
  padding: 10px 2px 0;
`;
const PortfolioMobileTab = styled.button`
  min-height: 56px;
  border-radius: 16px;
  border: 1.5px solid ${(props) => (props.$active ? 'rgba(8,145,178,.26)' : 'transparent')};
  background: ${(props) => (props.$active ? '#eaf7fb' : 'transparent')};
  color: ${(props) => (props.$active ? '#0891b2' : '#0c1a2e')};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  font-size: 9px;
  font-weight: 800;
  line-height: 1.1;
  padding: 4px;
`;
const PortfolioMobileCount = styled.div`
  padding: 2px 4px 0;
  font-size: 13px;
  font-weight: 800;
  color: #7e98b5;
`;
const PortfolioMobileBookCard = styled.div`
  width: 100%;
  border-radius: 24px;
  background: #ffffff;
  border: 1.5px solid rgba(8, 145, 178, 0.1);
  box-shadow: 0 10px 24px rgba(8, 145, 178, 0.12);
  overflow: hidden;
  margin-bottom: 14px;
`;
const PortfolioMobileBookTop = styled.div`
  display: grid;
  grid-template-columns: 94px minmax(0, 1fr);
  gap: 0;
  align-items: stretch;
`;
const PortfolioMobileCoverWrap = styled.div`
  background: linear-gradient(180deg, #cde0fb 0%, #d8ecff 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 132px;
`;
const PortfolioMobileCover = styled.img`
  width: 72px;
  height: 90px;
  object-fit: contain;
  object-position: center;
`;
const PortfolioMobileBookMeta = styled.div`
  padding: 14px 14px 12px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 6px;
  min-width: 0;
`;
const PortfolioMobileBookTitle = styled.div`
  font-size: 13px;
  font-weight: 900;
  color: #0c1a2e;
  line-height: 1.3;
`;
const PortfolioMobileBookAuthor = styled.div`
  font-size: 12px;
  font-weight: 800;
  color: #3f8fb7;
  line-height: 1.2;
`;
const PortfolioMobileTagRow = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
`;
const PortfolioMobileTag = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 22px;
  padding: 0 10px;
  border-radius: 999px;
  background: #f3fbff;
  border: 1px solid rgba(8, 145, 178, 0.16);
  color: #6e8aa8;
  font-size: 10px;
  font-weight: 800;
  line-height: 1;
`;
const PortfolioMobileTable = styled.div`
  display: grid;
  grid-template-columns: repeat(${(props) => props.$columns || 4}, minmax(0, 1fr));
  border-top: 1px solid rgba(8, 145, 178, 0.14);
  border-bottom: 1px solid rgba(8, 145, 178, 0.14);
`;
const PortfolioMobileTableCell = styled.div`
  min-height: ${(props) => (props.$header ? '36px' : '38px')};
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${(props) => (props.$header ? '6px 4px 4px' : '8px 4px')};
  background: ${(props) => (props.$header ? '#edf7ff' : '#ffffff')};
  color: ${(props) => props.$color || (props.$header ? '#8aa0ba' : '#37506c')};
  font-size: ${(props) => (props.$header ? '8px' : '10px')};
  font-family: ${(props) => (props.$header ? "'JetBrains Mono', monospace" : "'Nunito', sans-serif")};
  font-weight: ${(props) => (props.$header ? 700 : 900)};
  letter-spacing: ${(props) => (props.$header ? '.16em' : 'normal')};
  text-transform: ${(props) => (props.$header ? 'uppercase' : 'none')};
  border-right: 1px solid rgba(8, 145, 178, 0.14);
  &:nth-child(${(props) => props.$columns}n) {
    border-right: 0;
  }
`;
const PortfolioMobileActionRow = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
  padding: 12px 14px 14px;
`;
const PortfolioMobileActionButton = styled.button`
  min-height: 42px;
  border-radius: 16px;
  border: 1.5px solid ${(props) => (props.$primary ? 'rgba(249, 115, 22, 0.28)' : 'rgba(8, 145, 178, 0.18)')};
  background: ${(props) => (props.$primary ? '#fff7ea' : '#e9f8ff')};
  color: ${(props) => (props.$primary ? '#f59e0b' : '#0891b2')};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 900;
  padding: 0 10px;
`;
const PortfolioMobileBottomNav = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  background: #ffffff;
  border-top: 1.5px solid rgba(8, 145, 178, 0.12);
  box-shadow: 0 -4px 20px rgba(8, 145, 178, 0.1);
  padding-bottom: env(safe-area-inset-bottom, 0px);
  z-index: 40;
`;
const PortfolioMobileBottomNavItem = styled.button`
  padding: 10px 4px 8px;
  border: 0;
  background: transparent;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 3px;
  color: ${(props) => (props.$active ? '#0891b2' : '#8fa3bb')};
  font-size: 10px;
  font-weight: 700;
`;
const MobileLevelBar = styled.div`
  width: 100%;
  background-color: #ddd4c7;
  padding: 8px 15px;
  display: flex;
  justify-content: flex-start;
`;
const MobileLevelDropdown = styled.div`
  background-color: #ffffff;
  height: 32px;
  min-width: 140px;
  border-radius: 8px;
  font-size: 13px;
  color: #6b4b32;
  font-weight: 600;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 24px 0 12px;
  background-image: url('/images/LevelUp/mobileHeaderTriangle.png');
  background-repeat: no-repeat;
  background-size: 10px 9px;
  background-position: right 8px center;
  cursor: pointer;
`;
const MainWrapper = styled.div`
  display: flex;
  flex-direction: ${({ $isMobile }) => ($isMobile ? 'column' : 'row')};
  min-height: ${({ $isMobile }) => ($isMobile ? 'auto' : 'calc(100vh - 64px)')};
  height: ${({ $isMobile }) => ($isMobile ? 'auto' : 'calc(100vh - 64px)')};
  width: 100%;
  margin: 0;
  padding: ${({ $isMobile, $searchOpen }) => ($isMobile ? ($searchOpen ? '108px 0 0' : '64px 0 0') : '0')};
  box-sizing: border-box;
  overflow: ${({ $isMobile }) => ($isMobile ? 'visible' : 'hidden')};
  overflow-x: hidden;
`;
const Main = styled.div`
  flex: 1;
  min-width: 0;
  min-height: 0;
  height: ${({ $isMobile }) => ($isMobile ? 'auto' : 'calc(100vh - 64px)')};
  padding: ${({ $isMobile }) => ($isMobile ? '0 0 16px' : '12px 24px 0')};
  background-color: transparent;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: ${({ $isMobile }) => ($isMobile ? '0' : '16px')};
  overflow: ${({ $isMobile }) => ($isMobile ? 'visible' : 'hidden')};
`;
const MainHead = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 12px 18px;
  border: 1.5px solid rgba(8, 145, 178, 0.12);
  border-radius: 20px;
  background: #ffffff;
  box-shadow: 0 2px 12px rgba(8, 145, 178, 0.12);
  font-size: 15px;
  flex-shrink: 0;
`;
const MainHeadBox = styled.div`
  display: flex;
  flex-direction: row;
`;
const SelectBox = styled(Select)`
  height: 36px;
  width: 130px;
  border-radius: 14px;
`;
const SearchInput = styled(Input)`
  height: 36px;
  width: 150px;
  border-radius: 18px;
  border: 1.5px solid rgba(8, 145, 178, 0.12);
  :hover {
    border: 1.5px solid rgba(8, 145, 178, 0.12);
  }
`;
const MidBox = styled(ColumnFlex)`
  justify-content: space-between;
  padding: 10px;
  width: 720px;
  min-width: 0;
  @media (max-width: 1400px) {
    width: 560px;
  }
  @media (max-width: 1280px) {
    width: 500px;
  }
  @media (max-width: 768px) {
    width: auto;
    padding: 0;
    flex: 1 1 auto;
  }
`;
const TimeSpan = styled.span`
  @media (max-width: 1400px) {
    display: none;
  }
`;
const ContentWrapper = styled.div`
  flex: ${({ $isMobile }) => ($isMobile ? '0 0 auto' : '1 1 0')};
  min-height: 0;
  padding-top: ${({ $isMobile }) => ($isMobile ? '0' : '8px')};
  overflow-y: ${({ $isMobile }) => ($isMobile ? 'visible' : 'auto')};
  overflow-x: hidden;
  &::-webkit-scrollbar {
    width: 3px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: rgba(8, 145, 178, 0.22);
    border-radius: 2px;
  }
`;
const PaginationRow = styled(RowFlex)`
  justify-content: center;
  margin-top: 5px;
  gap: 8px;
  flex-shrink: 0;
`;
const PortfolioPagerButton = styled.button`
  width: 28px;
  height: 28px;
  border-radius: 8px;
  border: 1.5px solid rgba(8, 145, 178, 0.14);
  background: ${(props) => (props.$active ? '#0891b2' : '#ffffff')};
  color: ${(props) => (props.$active ? '#ffffff' : '#64748b')};
  font-family: 'Nunito', sans-serif;
  font-size: 12px;
  font-weight: 800;
  line-height: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.18s ease;
  box-shadow: 0 2px 8px rgba(8, 145, 178, 0.08);
  &:hover:not(:disabled) {
    background: #0891b2;
    border-color: #0891b2;
    color: #ffffff;
  }
  &:disabled {
    opacity: 0.45;
    cursor: default;
  }
`;
const ContentBox = styled(RowFlex)`
  width: 100%;
  border: 1.5px solid rgba(8, 145, 178, 0.12);
  border-radius: 20px;
  justify-content: space-between;
  margin: 0 0 14px;
  padding: 20px 22px;
  background: #ffffff;
  box-shadow: 0 2px 12px rgba(8, 145, 178, 0.12);
  display: grid;
  grid-template-columns: 108px minmax(0, 1.45fr) 148px 154px;
  gap: 24px;
  align-items: start;
  @media (max-width: 768px) {
    align-items: flex-start;
    height: auto;
    max-height: none;
    padding: 10px;
    gap: 10px;
    display: flex;
  }
`;

const ThumbNail = styled.img`
  width: 108px;
  height: 118px;
  border-radius: 14px;
  object-fit: contain;
  object-position: center;
  background: #ffffff;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  @media (max-width: 768px) {
    width: 70px;
    height: 70px;
    margin: 0;
  }
`;

const AssignedIcon = styled(ScheduleTwoTone)`
  position: absolute;
  top: 8px;
  right: 8px;
  padding: 4px;
  background: rgba(255, 255, 255, 0.82);
  font-size: 18px;
  height: 18px;
  border-radius: 5px;
  z-index: 111;
`;

const ContentText = styled.div`
  color: #4a6380;
  font-size: 12px;
  font-weight: 600;
  padding: 0 0 4px;
  @media (max-width: 1280px) {
    font-size: 12px;
  }
  @media (max-width: 768px) {
    font-size: 13px;
    padding: 0 0 8px;
  }
`;
const MobileMetaStack = styled(ColumnFlex)`
  gap: 4px;
  font-size: 12px;
  color: #595959;
  width: 100%;
  min-width: 0;
  margin-bottom: 6px;
`;
const MobileMetaLine = styled.span`
  width: 100%;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
const GridItem = styled.div`
  text-align: center;
  padding: ${(props) => (props.isHeader ? '.35rem 1rem' : '.4rem 1rem')};
  width: auto;
  min-width: 86px;
  font-size: ${(props) => (props.isHeader ? '9px' : '12px')};
  font-family: ${(props) => (props.isHeader ? "'JetBrains Mono', monospace" : "'Nunito', sans-serif")};
  font-weight: ${(props) => (props.isHeader ? 700 : 700)};
  letter-spacing: ${(props) => (props.isHeader ? '.1em' : 'normal')};
  text-transform: ${(props) => (props.isHeader ? 'uppercase' : 'none')};
  background-color: ${(props) => (props.isHeader ? '#d4ecf7' : '#ffffff')};
  color: ${(props) => (props.color ? props.color : props.isHeader ? '#4a6380' : '#1e3a5f')};
  border-right: 1px solid rgba(8, 145, 178, 0.12);
  border-top: ${(props) => (!props.isHeader ? '1px solid rgba(8, 145, 178, 0.12)' : 'none')};
  border-bottom: none;
  border-left: none;
  @media (max-width: 1400px) {
    font-size: 12px;
  }
  @media (max-width: 1280px) {
    font-size: 12px;
  }
  @media (max-width: 1150px) {
    font-size: 12px;
  }
  @media (max-width: 768px) {
    font-size: ${(props) => (props.isHeader ? '8px' : '10px')};
    padding: ${(props) => (props.isHeader ? '8px 4px 6px' : '9px 4px')};
    width: auto;
    min-width: 0;
    flex: ${(props) => (props.time ? '1.6 1 0' : '1.1 1 0')};
  }
`;
const ActivityTable = styled.div`
  display: grid;
  grid-template-columns: repeat(${(props) => props.$columns || 2}, minmax(86px, 1fr));
  width: fit-content;
  max-width: 100%;
  border: 1px solid rgba(8, 145, 178, 0.12);
  @media (max-width: 768px) {
    width: 100%;
    grid-template-columns: repeat(${(props) => props.$columns || 2}, minmax(0, 1fr));
    border-left: 0;
    border-right: 0;
    border-bottom: 0;
  }
`;
const IconImg = styled.img`
  display: none;
  @media (max-width: 768px) {
    height: 44px;
    max-height: 44px;
    width: 44px;
    max-width: 44px;
  }
`;
const IconText = styled.div`
  color: #334155;
  font-size: ${(props) => (props.isNoReport ? '20px' : '11px')};
  font-weight: 800;
  line-height: 1.15;
  @media (max-width: 768px) {
    font-size: 11px;
  }
`;
const FluencyColumn = styled(ColumnFlex)`
  min-width: 154px;
  align-items: center;
  justify-content: flex-start;
  align-self: start;
  text-align: center;
  gap: 10px;
`;
const MobileCountRow = styled(RowFlex)`
  width: 100%;
  justify-content: flex-start;
  color: #666666;
  font-size: 13px;
  padding: 10px 0 0;
`;
const ThumbColumn = styled(RowFlex)`
  width: 108px;
  position: relative;
  justify-content: center;
  align-items: flex-start;
  align-self: start;
  @media (max-width: 768px) {
    width: 70px;
  }
`;
const RightMeta = styled.div`
  width: 148px;
  font-size: 12px;
  @media (max-width: 768px) {
    width: 80px;
    font-size: 10px;
  }
`;
const ImgButton = styled.img`
  cursor: pointer;
  width: 43px;
  height: 43px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 10px;
`;
const FluencyCircle = styled.button`
  width: 58px;
  height: 58px;
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 3px;
  border: 2px solid rgba(8, 145, 178, 0.16);
  background: ${(props) => (props.$done ? 'linear-gradient(135deg,#f59e0b,#f97316)' : '#eff8fb')};
  color: ${(props) => (props.$done ? '#ffffff' : '#475569')};
  box-shadow: ${(props) => (props.$done ? '0 4px 14px rgba(245,158,11,.35)' : 'none')};
  cursor: ${(props) => (props.$disabled ? 'default' : 'pointer')};
  transition: all 0.18s ease;
  &:hover {
    transform: ${(props) => (props.$disabled ? 'none' : 'scale(1.08)')};
    border-color: ${(props) => (props.$disabled ? 'rgba(8, 145, 178, 0.16)' : '#0891b2')};
  }
`;
const FluencyIcon = styled.span`
  font-size: 24px;
  line-height: 1;
`;
const FluencyLabel = styled.span`
  font-size: 9px;
  font-weight: 800;
  line-height: 1;
`;
const ActionGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;
const ActionButton = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3px;
  padding: 8px 10px;
  border-radius: 14px;
  border: 1.5px solid rgba(8, 145, 178, 0.12);
  background: #ffffff;
  cursor: pointer;
  transition: all 0.18s ease;
  color: #475569;
  font-size: 9px;
  font-weight: 800;
  line-height: 1.15;
  &:hover {
    border-color: rgba(8, 145, 178, 0.32);
    color: #0891b2;
    background: rgba(8, 145, 178, 0.06);
    transform: translateY(-2px);
  }
`;
const ActionIcon = styled.span`
  font-size: 22px;
  line-height: 1;
`;
const ActionArrow = styled.span`
  font-size: 14px;
  font-weight: 700;
  color: #94a3b8;
`;
const TabBar = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
  background: #ffffff;
  border-radius: 20px;
  padding: 10px;
  border: 1.5px solid rgba(8, 145, 178, 0.12);
  box-shadow: 0 2px 12px rgba(8, 145, 178, 0.12);
  flex-shrink: 0;
`;
const TabButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 16px;
  border-radius: 14px;
  border: 1.5px solid transparent;
  background: ${(props) => (props.$active ? 'linear-gradient(135deg,#0891b2,#06b6d4)' : 'transparent')};
  color: ${(props) => (props.$active ? '#ffffff' : '#4a6380')};
  font-size: 14px;
  font-weight: 800;
  cursor: pointer;
`;
const useCheckScreen = () => {
  const [width, setWidth] = useState(window.innerWidth);
  const [height, setHeight] = useState(window.innerHeight);
  const handleWindowSizeChange = () => {
    setHeight(window.innerHeight);
    setWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener('resize', handleWindowSizeChange);
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    };
  }, []);

  return [width > 1600 ? 1 : width / 1600, height > 900 ? 1 : height / 900];
};
export default function LevelUpPortfolio() {
  let width = useCheckScreen()[0];
  let height = useCheckScreen()[1];
  const isMobileView = window.isNativeAppMobile || isMobileOnly;
  const wrapperRef = useRef(null);
  const { student_idx, name, studentid, month } = queryString.parse(window.location.search);
  const history = useHistory();
  const [selectValue, setSelectValue] = useState('all');
  const [recordingTitle, setRecordingTitle] = useState('Recording');
  const [isRecordingVisible, setIsRecordingVisible] = useState(false);
  const [excelDownVisible, setExcelDownVisible] = useState(false);
  const [mobileLevelValue, setMobileLevelValue] = useState(null);
  const [currentUserName, setCurrentUserName] = useState('');
  const [currentUserId, setCurrentUserId] = useState('');
  const [recordingContent, setRecordingContent] = useState('');
  const [currentLevel, setCurrentLevel] = useState(null);
  const companyName = useSelector(classStoreData);
  const [searchValue, setSearchValue] = UseHistoryState(
    {
      type: 'publisher',
      text: '',
      page: 1,
      pageSize: 20,
      student_idx,
      name,
      studentid,
      by_completed_date: true,
    },
    'levelup_portfolio_search',
  );
  useEffect(() => {
    if (month) {
      setSelectValue(month);
    }
  }, [month]);
  const isSelfBookReport = useMemo(() => {
    let etcData = userInfoVar()?.campus?.etc
      ? JSON.parse(userInfoVar()?.campus?.etc)
      : {
          isSelfBookReport: false,
        };

    return etcData?.isSelfBookReport === false ? false : true;
  }, []);

  const isLevelupRecording = useMemo(() => {
    let etcData = userInfoVar()?.campus?.etc
      ? JSON.parse(userInfoVar()?.campus?.etc)
      : {
          isLevelupRecording: true,
        };

    return etcData?.isLevelupRecording === false ? false : true;
  }, []);

  const getLatestClassLevel = (classes = []) => {
    const latestClass = _.orderBy(
      classes.filter((classInfo) => classInfo?.levelup_level),
      [
        (classInfo) => {
          const beginDate = moment(classInfo?.begin_date);
          return beginDate.isValid() ? beginDate.valueOf() : 0;
        },
      ],
      ['desc'],
    )[0];

    return latestClass?.levelup_level || '';
  };

  let getUserType = GET_STUDENT_LUPUSER;
  if (userInfoVar() && userInfoVar()?.type !== '0' && userInfoVar()?.type !== 0) {
    getUserType = GET_TEACHER_USER;
  }

  useQuery(getUserType, {
    variables: {},
    onCompleted: (data) => {
      if (!data?.getUserData) return;
      let tempData = data.getUserData;
      if (tempData.class_teacher) {
        tempData = Object.assign({}, tempData, { classes: tempData.class_teacher.map((item) => item.class) });
      } else {
        tempData = Object.assign({}, tempData, { classes: tempData.class_student.map((item) => item.class) });
      }

      if (tempData?.user_levelup_tests?.length > 0) {
        const sortedTests = _.orderBy(
          tempData.user_levelup_tests.filter((item) => item.level),
          ['test_end_date'],
          ['desc'],
        );
        const latestTest = sortedTests[0];
        if (latestTest?.lexile && latestTest?.level) {
          setCurrentLevel(latestTest.level);
          return;
        }
      }

      setCurrentLevel(getLatestClassLevel(tempData?.classes));
    },
  });

  const handleSelectChange = (v) => {
    setSelectValue(v);
    setSearchValue((prev) => {
      return {
        ...prev,
        page: 1,
      };
    });
  };

  const user_idx = userInfoVar()?.idx || null;
  // const { data, loading } = useQuery(EXTERNAL_USER_STUDY_LEVELUP, {
  //   variables: {
  //     user_idx: student_idx ? parseInt(student_idx) : parseInt(user_idx),
  //     ym: selectValue === 'all' ? null : selectValue,
  //     start_date: selectValue === 'all' ? `${moment().add(-3, 'months').format('YYYY-MM')}-01` : null,
  //     end_date: selectValue === 'all' ? `${moment().format('YYYY-MM')}-${moment().daysInMonth()}` : null,
  //     type: 'levelup',
  //     status_gte: 2,
  //   },
  //   fetchPolicy: 'no-cache',
  //   skip: !user_idx,
  // });
  const { data, loading } = useQuery(EXTERNAL_USER_STUDY_LIST_LEVELUP, {
    variables: {
      ym: selectValue === 'all' ? null : selectValue,
      type: 'levelup',
      user_idx: searchValue.student_idx ? parseInt(searchValue.student_idx) : parseInt(user_idx),
      start_date: null,
      end_date: null,
      status_gte: 2,
      page: searchValue.page - 1,
      take: searchValue.pageSize,
      by_completed_date: searchValue.by_completed_date,
    },
    fetchPolicy: 'no-cache',
    skip: !user_idx,
  });
  const onChangePage = (page) => {
    setSearchValue((prev) => {
      return {
        ...prev,
        page: page,
      };
    });
  };
  const portfolioTotalPages = Math.max(1, Math.ceil((data?.getExternalStuiesListPage?.total || 0) / searchValue.pageSize));
  const studyData = useMemo(() => {
    if (data?.getExternalStuiesListPage) {
      return data?.getExternalStuiesListPage?.external_user_study
        .sort((a, b) => {
          if (moment(a.study_date).isSameOrAfter(b.study_date)) {
            return -1;
          }
          return 1;
        })
        .map((item, key) => {
          const externalStudy =
            item?.external_study_data?.length === 0
              ? JSON.parse(item?.article_data)
              : JSON.parse(item?.external_study_data?.external_study_data);
          console.log(externalStudy, 'externalStudyexternalStudy');
          const recording_data = item.recording_data;
          const {
            study_date,
            article_data,
            exam_total,
            exam_correct,
            wpm,
            external_study_idx,
            data,
            last_study_timestamp,
            assigned_idx,
            external_study_stage,
            user,
          } = item;
          // const dataparse = JSON.parse(data);
          // const score = dataparse?.score_percent || '';
          const { id, name } = user;
          let quizStage = external_study_stage.filter((item) => item.stage_no === 3) || [];
          quizStage = quizStage[0] || {};

          let activitiesStage = external_study_stage.filter((item) => [1, 2, 4, 5].includes(item.stage_no)) || [];
          const {
            lexile_val,
            issue_date,
            title,
            mx_level: level,
            pages,
            code,
            mxObj,
            genre__1,
            author,
            publisher,
            is_voca,
          } = JSON.parse(
            article_data || {
              lexileScore: '',
              issue_date: '',
              title: '',
              level: '',
              image: '',
              pages: '',
              code: '',
              mxObj: '',
              publisher: '',
              author: '',
              is_voca: false,
            },
          );
          const { bookId, gamePlayResults, lastPageVisited, startedAt, timeSpent } = JSON.parse(data) || {
            bookId: 0,
            gamePlayResults: [],
            lastPageVisited: 0,
            pagesVisited: [],
            startedAt: '',
            timeSpent: 0,
          };
          const date = moment(study_date).format('M월D일');
          const articleData = {
            lexile: lexile_val,
            issue_date: moment(study_date).format('YYYY-MM-DD HH:mm:SS'),
            image: `https://cdn.cloubot.com/LEVELUP/covers/${code}.png`,
            level,
            title,
            assigned_idx,
            is_voca,
            code,
          };
          const achievement = gamePlayResults
            ? gamePlayResults.reduce(
                (acc, cur) => {
                  if (cur.numberOfAttempts) {
                    acc.score += cur.numberOfAttempts;
                    acc.total += cur.numberOfElements;
                  } else if (cur.numberOfCorrectAttempts) {
                    acc.score += cur.numberOfCorrectAttempts;
                    acc.total += cur.numberOfElements;
                  } else if (cur.status == 1) {
                    acc.score += 1;
                    acc.total += 1;
                  }
                  return { ...acc };
                },
                { score: 0, total: 0 },
              )
            : {
                score: 0,
                total: 0,
              };
          const time =
            (parseInt(timeSpent / 3600, 10) > 0 ? `${parseInt(timeSpent / 3600, 10)}시간 ` : '') +
            (parseInt((timeSpent % 3600) / 60, 10) > 0 ? `${parseInt((timeSpent % 3600) / 60, 10)}분 ` : '') +
            `${parseInt(timeSpent % 60, 10)}초`;
          return {
            key: `levelup-list-${key}`,
            date,
            id,
            name,
            lexileScore: lexile_val ? lexile_val : '-',
            issue_date,
            title,
            level,
            author,
            publisher,
            mx_level: level,
            lexile: lexile_val,
            pages,
            grl: genre__1 || '',
            image: `https://cdn.cloubot.com/LEVELUP/covers/${code}.png`,
            accuracy: recording_data ? `${Math.round((100 * exam_correct) / exam_total)}%` : '',
            wpm,
            recording_data,
            idx: item?.idx,
            assigned_idx,
            quiz: quizStage?.exam_total ? `${Math.round((100 * quizStage?.exam_correct) / quizStage?.exam_total)}%` : '',
            activities: activitiesStage?.length > 3 || !is_voca ? '✅' : '-',
            // exam_total,
            // exam_correct,
            achievement: achievement.score > 0 ? `${Math.round((achievement.score * 100) / achievement.total)}%` : '0%',
            book_id: external_study_idx || bookId,
            gamePlayResults,
            last_study_timestamp: last_study_timestamp ? `${last_study_timestamp.slice(0, 10)} ${last_study_timestamp.slice(11, 19)}` : '-',
            lastPageVisited,
            time: timeSpent > 0 ? time : '-',
            startedAt: startedAt ? `${startedAt.slice(0, 10)} ${startedAt.slice(11, 19)}` : '-',
            timeSpent: Math.round(timeSpent),
            articleData,
            selfStudy: assigned_idx === null,
            externalStudy,
            data: item?.data ? JSON?.parse(item.data) : {},
            is_voca,
          };
        });
    }
    return [];
  }, [data]);

  const books = useMemo(() => {
    if (studyData.length > 0) {
      return searchValue.text !== ''
        ? studyData.filter((item) => item.title.toLowerCase().includes(searchValue.text.toLowerCase()))
        : studyData;
    }
    return studyData;
  }, [studyData, searchValue.text]);

  const handleInputChange = (e) => {
    setSearchValue((prev) => {
      return {
        ...prev,
        text: e.target.value,
      };
    });
  };
  const handleSearch = (e) => {
    console.log(searchValue.text);
  };
  const getMobileTitleText = (title) => {
    if (!title) return '';
    return title.length > 13 ? `${title.slice(0, 13)}...` : title;
  };
  const openRecordingDataModal = (data, name, id, title) => {
    setIsRecordingVisible(true);
    setRecordingContent(data);
    setCurrentUserName(name);
    setCurrentUserId(id);
    setRecordingTitle(title);
  };
  function handleOkForRecordingData() {
    setIsRecordingVisible(false);
  }
  const getActivities = (e) => {
    const desktopVocaHeaders =
      e?.externalStudy?.bookreport && e?.externalStudy?.bookreport !== undefined
        ? ['Activities', 'Quiz',  'WPM', 'Book Report', 'Time']
        : ['Activities', 'Quiz',  'WPM', 'Time'];
    const mobileVocaHeaders = ['Acts.', 'Quiz',  'WPM', 'Time'];
    const phonicsHeaders = window.isNativeAppMobile || isMobileOnly ? ['Acts.', 'Time'] : ['Activities', 'Time'];

    return (
      <ColumnFlex>
        {e.articleData?.is_voca ? (
          <>
            <ActivityTable $columns={(window.isNativeAppMobile || isMobileOnly ? mobileVocaHeaders : desktopVocaHeaders).length}>
              {(window.isNativeAppMobile || isMobileOnly ? mobileVocaHeaders : desktopVocaHeaders).map((item) => (
                <GridItem key={item} time={item === 'Time'} isHeader>
                  {item}
                </GridItem>
              ))}
              <GridItem color={'#548235'}>{e.activities}</GridItem>
              <GridItem color={'#ff002a'}>{e.quiz}</GridItem>
              <GridItem
                onClick={() => e.wpm && e.accuracy && openRecordingDataModal(e, e.name, e.id, 'Recording')}
                color={'#4472c4'}
                style={{ cursor: e.wpm ? 'pointer' : 'default' }}
              >
                {/* {e.wpm}/{e.accuracy} */}
                {(e?.wpm === null || e?.wpm === '') && (e?.accuracy === null || e?.accuracy === '') ? '-' : `${e.wpm}/${e.accuracy}`}
              </GridItem>
              {!(window.isNativeAppMobile || isMobileOnly) && e?.externalStudy?.bookreport && e?.externalStudy?.bookreport !== undefined ? (
                e?.data?.rubric_data && e?.externalStudy?.bookreport !== undefined ? (
                  <GridItem color={JSON.parse(e?.data?.rubric_data)?.pdf_url ? '#548235' : '#ff002a'}>
                    {JSON.parse(e?.data?.rubric_data)?.pdf_url ? 'O' : 'X'}
                  </GridItem>
                ) : (
                  e?.externalStudy?.bookreport && e?.externalStudy?.bookreport !== undefined && <GridItem color={'#ff002a'}>{'X'}</GridItem>
                )
              ) : undefined}
              <GridItem time={true} color={'#4472c4'}>
                {moment(e.last_study_timestamp).format('MM-DD HH:mm')}
              </GridItem>
            </ActivityTable>
          </>
        ) : (
          <>
            <ActivityTable $columns={phonicsHeaders.length}>
              {phonicsHeaders.map((item) => (
                <GridItem key={item} time={item === 'Time'} isHeader>
                  {item}
                </GridItem>
              ))}
              <GridItem color={'#548235'}>{e.activities}</GridItem>
              <GridItem time={true} color={'#4472c4'}>
                {moment(e.last_study_timestamp).format(window.isNativeAppMobile || isMobileOnly ? 'MM-DD HH:mm' : 'YY-MM-DD HH:mm')}
              </GridItem>
            </ActivityTable>
          </>
        )}
      </ColumnFlex>
    );
  };

  const handleImgClick = (code, exStudyIdx, data, fromRecording, fullData) => {
    if (data?.status === 2) {
      if (fromRecording) {
        let recordingData = data?.recording_data ? JSON.parse(data.recording_data) : {};
        recordingData = {
          ...recordingData,
          accuracy: recordingData?.accuracy || `${recordingData?.score}%`,
          wpm: recordingData?.wpm || recordingData?.speed,
        };
        openRecordingDataModal(recordingData, data?.user?.name, data?.user?.id, 'Presentation');
      } else {
        const rubricData = data?.rubric_data ? JSON.parse(data.rubric_data) : {};
        if (rubricData?.pdf_url === undefined || rubricData?.pdf_url === null || rubricData?.pdf_url === '') {
          alert("Please wait for teacher's feedback");
        } else {
          if (window.confirm('완료한 학습입니다. Report Page로 이동시겠습니까?')) {
            window.open(rubricData?.pdf_url);
          } else {
            return;
          }
        }
      }
    } else {
      history.push(`/level-up/bookreport?code=${code}&external_study_idx=${exStudyIdx}`);
    }
  };
  function handleOpenExcelModal(e) {
    e.preventDefault();
    setExcelDownVisible(true);
  }
  return (
    <>
      <Wrapper ref={wrapperRef} $isMobile={isMobileView}>
        {isMobileView ? (
          <PortfolioMobilePage>
            <PortfolioMobileAppHeader>
              <PortfolioMobileHeaderBrand>
                <PortfolioMobileHeaderLogo />
                <PortfolioMobileHeaderName>
                  e-<span>Library</span>
                </PortfolioMobileHeaderName>
              </PortfolioMobileHeaderBrand>
              <PortfolioMobileHeaderActions>
                <PortfolioMobileHeaderRound type="button" onClick={() => history.push('/level-up/calendar')}>
                  {'\u{1F514}'}
                </PortfolioMobileHeaderRound>
                <PortfolioMobileHeaderRound type="button" onClick={() => history.push('/')}>
                  <PoweroffOutlined />
                </PortfolioMobileHeaderRound>
              </PortfolioMobileHeaderActions>
            </PortfolioMobileAppHeader>
          </PortfolioMobilePage>
        ) : null}
        <MainWrapper className="test123" $isMobile={isMobileView} $searchOpen={mobileLevelValue === 'search'}>
          {!isMobileView && (
            <LeftMenu2
              myLevel={parseInt(userInfoVar()?.type || 0, 10) !== 0 ? -2 : currentLevel === 'PH' ? 0 : parseInt(currentLevel, 10)}
              isStudent={parseInt(userInfoVar()?.type || 0, 10) === 0}
            />
          )}
          <Main $isMobile={isMobileView}>
            {!isMobileView && <LevelUpLibraryMenuGroup3 currentMenu="portfolio" student_idx={student_idx} />}

            {isMobileView ? (
              <PortfolioMobileInner>
                <PortfolioMobileTabsShell $searchOpen={mobileLevelValue === 'search'}>
                  <PortfolioMobileTabs>
                    <PortfolioMobileTab type="button" onClick={() => history.push('/level-up/favorite')}>
                      <span>{'\u2764\uFE0F'}</span>
                      <span>Favorite</span>
                    </PortfolioMobileTab>
                    <PortfolioMobileTab type="button" onClick={() => history.push('/level-up/inprogress')}>
                      <span>{'\u{1F4D6}'}</span>
                      <span>In Progress</span>
                    </PortfolioMobileTab>
                    <PortfolioMobileTab type="button" $active>
                      <span>{'\u2705'}</span>
                      <span>Portfolio</span>
                    </PortfolioMobileTab>
                    <PortfolioMobileTab type="button" onClick={() => history.push('/level-up/calendar')}>
                      <span>{'\u{1F3C6}'}</span>
                      <span>Pts & Cal</span>
                    </PortfolioMobileTab>
                  </PortfolioMobileTabs>
                </PortfolioMobileTabsShell>
                <PortfolioMobileTabsSpacer $searchOpen={mobileLevelValue === 'search'} />

                <PortfolioMobileFilterCard>
                  <RowFlex style={{ gap: 8 }}>
                    <SelectBox bordered={false} value={selectValue} onChange={handleSelectChange} style={{ width: '42%' }}>
                      <Option key={0} value="all">
                        전체
                      </Option>
                      {[
                        moment().format('YYYY-MM'),
                        moment().subtract(1, 'months').format('YYYY-MM'),
                        moment().subtract(2, 'months').format('YYYY-MM'),
                        moment().subtract(3, 'months').format('YYYY-MM'),
                        moment().subtract(4, 'months').format('YYYY-MM'),
                        moment().subtract(5, 'months').format('YYYY-MM'),
                        moment().subtract(6, 'months').format('YYYY-MM'),
                        moment().subtract(7, 'months').format('YYYY-MM'),
                        moment().subtract(8, 'months').format('YYYY-MM'),
                        moment().subtract(9, 'months').format('YYYY-MM'),
                        moment().subtract(10, 'months').format('YYYY-MM'),
                        moment().subtract(11, 'months').format('YYYY-MM'),
                      ].map((item, key) => (
                        <Option key={key + 1} value={item}>
                          {item}
                        </Option>
                      ))}
                    </SelectBox>
                    <SearchInput
                      value={searchValue.text}
                      onChange={handleInputChange}
                      allowClear
                      bordered={false}
                      placeholder="Search title"
                      suffix={<SearchOutlined onClick={handleSearch} style={{ border: 'none' }} />}
                      style={{ width: '58%' }}
                    />
                  </RowFlex>
                </PortfolioMobileFilterCard>
                <PortfolioMobileCount>{`총 ${data?.getExternalStuiesListPage?.total || 0}권 완독`}</PortfolioMobileCount>
              </PortfolioMobileInner>
            ) : (
              <MainHead style={{ marginBottom: height < 0.8 && 0 }}>
                <MainHeadBox>{`총 ${data?.getExternalStuiesListPage?.total || 0}권`}</MainHeadBox>
                <MainHeadBox style={{ fontSize: '15px', lineHeight: '30px', alignItems: 'center' }}>
                  <Switch
                    checkedChildren="Completed Date"
                    unCheckedChildren="Study Date"
                    defaultChecked
                    style={{ marginRight: 10 }}
                    onChange={(checked) =>
                      setSearchValue((prev) => {
                        return {
                          ...prev,
                          by_completed_date: checked,
                          page: 1,
                        };
                      })
                    }
                  />
                  {searchValue.name && searchValue.studentid && (
                    <span style={{ marginRight: 10 }}>
                      {searchValue.name} (ID : {searchValue.studentid})
                    </span>
                  )}
                  <SelectBox bordered={false} value={selectValue} onChange={handleSelectChange}>
                    <Option key={0} value="all">
                      전체
                    </Option>
                    {[
                      moment().format('YYYY-MM'),
                      moment().subtract(1, 'months').format('YYYY-MM'),
                      moment().subtract(2, 'months').format('YYYY-MM'),
                      moment().subtract(3, 'months').format('YYYY-MM'),
                      moment().subtract(4, 'months').format('YYYY-MM'),
                      moment().subtract(5, 'months').format('YYYY-MM'),
                      moment().subtract(6, 'months').format('YYYY-MM'),
                      moment().subtract(7, 'months').format('YYYY-MM'),
                      moment().subtract(8, 'months').format('YYYY-MM'),
                      moment().subtract(9, 'months').format('YYYY-MM'),
                      moment().subtract(10, 'months').format('YYYY-MM'),
                      moment().subtract(11, 'months').format('YYYY-MM'),
                    ].map((item, key) => (
                      <Option key={key + 1} value={item}>
                        {item}
                      </Option>
                    ))}
                  </SelectBox>
                  &nbsp;
                  <SearchInput
                    onKeyUp={handleInputChange}
                    allowClear
                    bordered={false}
                    placeholder="Search"
                    suffix={<SearchOutlined onClick={handleSearch} style={{ border: 'none' }} />}
                  />
                </MainHeadBox>
              </MainHead>
            )}
            <ContentWrapper className="cust-portfolio-wrap" $isMobile={window.isNativeAppMobile || isMobileOnly}>
              {books.map((e, i) => {
                const hasMobileFluency = Boolean((Number(e.wpm) > 0 || !!e.recording_data || !!e.last_study_timestamp) && e.book_id);
                const hasMobileReport = Boolean((e?.externalStudy?.bookreport && e?.externalStudy?.bookreport !== undefined) || (isSelfBookReport && e.is_voca));
                return window.isNativeAppMobile || isMobileOnly ? (
                  <PortfolioMobileBookCard key={i}>
                    <PortfolioMobileBookTop>
                      <PortfolioMobileCoverWrap>
                        <PortfolioMobileCover src={e.image} alt={e.title} />
                      </PortfolioMobileCoverWrap>
                      <PortfolioMobileBookMeta>
                        <PortfolioMobileBookTitle>{getMobileTitleText(e.title)}</PortfolioMobileBookTitle>
                        <PortfolioMobileBookAuthor>{`✍️ ${e.author}`}</PortfolioMobileBookAuthor>
                        <PortfolioMobileTagRow>
                          <PortfolioMobileTag>{e?.lexileScore < 0 ? `BR${Math.abs(e?.lexileScore)}` : `${e?.lexileScore}L`}</PortfolioMobileTag>
                          <PortfolioMobileTag>{e.mx_level}</PortfolioMobileTag>
                        </PortfolioMobileTagRow>
                      </PortfolioMobileBookMeta>
                    </PortfolioMobileBookTop>
                    {renderMobilePortfolioTable(e)}
                    {(hasMobileFluency || hasMobileReport) && (
                      <PortfolioMobileActionRow style={{ gridTemplateColumns: hasMobileFluency && hasMobileReport ? 'repeat(2, minmax(0, 1fr))' : 'minmax(0, 1fr)' }}>
                        {hasMobileFluency && <FluencyButton book={e} done={!!e.wpm} isNoReport={false} isMobile />}
                        {hasMobileReport && (
                          <PortfolioMobileActionButton
                            type="button"
                            onClick={() => handleImgClick(e?.externalStudy?.code, e?.idx, e?.data, false, e)}
                          >
                            <span>📖</span>
                            <span>Report</span>
                          </PortfolioMobileActionButton>
                        )}
                      </PortfolioMobileActionRow>
                    )}
                  </PortfolioMobileBookCard>
                ) : (
                <ContentBox key={i} className="cust-portfolio">
                      <ThumbColumn>
                        <ThumbNail src={e.image} alt={e.title} />
                        {!e.selfStudy && <AssignedIcon />}
                      </ThumbColumn>

                      <MidBox>
                        <ContentText>{`Title : ${e.title}`}</ContentText>
                        <ContentText>{`Author : ${e.author}`}</ContentText>
                        {/* <RowFlex style={{ justifyContent: 'space-between' }}> */}
                        <ContentText>{`Page : ${e.pages}`}</ContentText>
                        {/* </RowFlex> */}
                        {getActivities(e)}
                      </MidBox>
                      <RightMeta>
                        <ColumnFlex style={{ padding: '10px' }}>
                          <ContentText>{`mx Level : ${e.mx_level}`}</ContentText>
                          <ContentText>{`Lexile : ${e?.lexileScore < 0 ? `BR${Math.abs(e?.lexileScore)}` : e?.lexileScore}`}</ContentText>
                          <ContentText>{`GRL : ${e.grl}`}</ContentText>
                        </ColumnFlex>
                      </RightMeta>
                  {/* <button onClick={()=>{console.log(e?.externalStudy?.bookreport,isSelfBookReport,e)}}>ddd</button> */}
                  {(e?.externalStudy?.bookreport && e?.externalStudy?.bookreport !== undefined) || (isSelfBookReport && e.is_voca) ? (
                    <>
                        <ColumnFlex style={{ alignItems: 'center', gap: 10 }}>
                          <FluencyButton book={e} done={!!e.wpm} isNoReport={false} />
                          <ActionGroup>
                            <ActionButton type="button" onClick={() => handleImgClick(e?.externalStudy?.code, e?.idx, e?.data, false, e)}>
                              <ActionIcon>📖</ActionIcon>
                              <span>Book Report</span>
                            </ActionButton>
                            {isLevelupRecording && (
                              <>
                                <ActionArrow>
                                  <ArrowRightOutlined />
                                </ActionArrow>
                                <ActionButton type="button" onClick={() => handleImgClick(e?.externalStudy?.code, e?.idx, e?.data, true, e)}>
                                  <ActionIcon>🎤</ActionIcon>
                                  <span>Presentation</span>
                                </ActionButton>
                              </>
                            )}
                          </ActionGroup>
                        </ColumnFlex>
                    </>
                  ) : (
                    <>
                      <ColumnFlex>
                        <FluencyButton book={e} done={!!e.wpm} isNoReport={true} />
                      </ColumnFlex>
                    </>
                  )}
                </ContentBox>
                );
              })}
            </ContentWrapper>
            <PaginationRow>
              <PortfolioPagerButton type="button" disabled={searchValue.page <= 1} onClick={() => onChangePage(searchValue.page - 1)}>
                {'‹'}
              </PortfolioPagerButton>
              <PortfolioPagerButton type="button" $active onClick={() => onChangePage(searchValue.page)}>
                {searchValue.page}
              </PortfolioPagerButton>
              <PortfolioPagerButton type="button" disabled={searchValue.page >= portfolioTotalPages} onClick={() => onChangePage(searchValue.page + 1)}>
                {'›'}
              </PortfolioPagerButton>
            </PaginationRow>
            {isMobileView && (
              <PortfolioMobileBottomNav>
                <PortfolioMobileBottomNavItem type="button" onClick={() => history.push('/level-up?mobilePage=home')}>
                  <span>{'\u{1F3E0}'}</span>
                  <span>Home</span>
                </PortfolioMobileBottomNavItem>
                <PortfolioMobileBottomNavItem type="button" onClick={() => history.push('/level-up/library?lv=1')}>
                  <span>{'\u{1F4DA}'}</span>
                  <span>Library</span>
                </PortfolioMobileBottomNavItem>
                <PortfolioMobileBottomNavItem type="button" $active>
                  <span>{'\u{1F4C2}'}</span>
                  <span>Portfolio</span>
                </PortfolioMobileBottomNavItem>
                <PortfolioMobileBottomNavItem type="button" onClick={() => history.push('/level-up?mobilePage=ranking')}>
                  <span>{'\u{1F3C6}'}</span>
                  <span>Ranking</span>
                </PortfolioMobileBottomNavItem>
                <PortfolioMobileBottomNavItem type="button" onClick={() => history.push('/level-up?mobilePage=profile')}>
                  <span>{'\u{1F464}'}</span>
                  <span>내 정보</span>
                </PortfolioMobileBottomNavItem>
              </PortfolioMobileBottomNav>
            )}
          </Main>
        </MainWrapper>
      </Wrapper>
      <RecordingDataModal
        data={{ ...recordingContent, currentUserName, currentUserId }}
        isShow={isRecordingVisible}
        onOk={handleOkForRecordingData}
        title={recordingTitle}
      />
    </>
  );
}

const FluencyButton = ({ book, done, isNoReport, isMobile }) => {
  const [hasData, setHasData] = useState(false);
  const history = useHistory();

  useEffect(() => {
    Promise.allSettled([axios.get(`https://cdn.cloubot.com/LEVELUP/texts/${book.book_id}.json`)])
      .then((responses) => {
        responses.forEach((res, idx) => {
          setHasData(res.status !== 'rejected');
        });
      })
      .catch((err) => console.log(err));
  }, [book]);

  const onHandleClick = () => {
    if (!hasData) {
      return;
    } else {
      if (done) {
        if (window.confirm('완료한 학습입니다. 다시하겠습니까?')) {
          history.push({
            pathname: `/level-up/recording/${book?.book_id}`,
            state: { articleData: book?.articleData, assigned_idx: book?.assigned_idx, idx: book?.idx },
          });
        } else {
          return;
        }
      } else {
        history.push({
          pathname: `/level-up/recording/${book?.book_id}`,
          state: { articleData: book?.articleData, assigned_idx: book?.assigned_idx, idx: book?.idx },
        });
      }
    }
  };

  return isMobile ? (
    <PortfolioMobileActionButton type="button" $primary onClick={onHandleClick} disabled={!hasData}>
      <span>🎙️</span>
      <span>Fluency</span>
    </PortfolioMobileActionButton>
  ) : (
    <FluencyCircle type="button" onClick={onHandleClick} $done={!!done} $disabled={!hasData}>
      <FluencyIcon>🎙️</FluencyIcon>
      <FluencyLabel>Fluency</FluencyLabel>
    </FluencyCircle>
  );
};
const renderMobilePortfolioTable = (book) => {
  if (book.is_voca) {
    const headers = ['quiz', 'wpm', 'date', 'activities'];
    const values = [book.quiz || '-', book.wpm || '-', moment(book.issue_date).format('MM-DD'), book.activities || '-'];
    return (
      <PortfolioMobileTable $columns={headers.length}>
        {headers.map((item, key) => (
          <PortfolioMobileTableCell key={`mobile-voca-head-${item}-${key}`} $header $columns={headers.length}>
            {item}
          </PortfolioMobileTableCell>
        ))}
        {values.map((item, key) => (
          <PortfolioMobileTableCell
            key={`mobile-voca-body-${headers[key]}-${key}`}
            $columns={headers.length}
            $color={headers[key] === 'quiz' ? '#ff5c66' : headers[key] === 'wpm' ? '#1199d6' : headers[key] === 'activities' ? '#27b15f' : '#37506c'}
          >
            {item}
          </PortfolioMobileTableCell>
        ))}
      </PortfolioMobileTable>
    );
  }

  const headers = ['activities', 'time'];
  const values = [book.activities || '-', moment(book.issue_date).format('MM-DD HH:mm')];
  return (
    <PortfolioMobileTable $columns={headers.length}>
      {headers.map((item, key) => (
        <PortfolioMobileTableCell key={`mobile-phonics-head-${item}-${key}`} $header $columns={headers.length}>
          {item}
        </PortfolioMobileTableCell>
      ))}
      {values.map((item, key) => (
        <PortfolioMobileTableCell key={`mobile-phonics-body-${headers[key]}-${key}`} $columns={headers.length}>
          {item}
        </PortfolioMobileTableCell>
      ))}
    </PortfolioMobileTable>
  );
};
const RecordingDataModal = ({ data, isShow, onOk, title }) => {
  return (
    <Modal
      title={title || 'Recording'}
      width="60%"
      visible={isShow}
      onOk={onOk}
      onCancel={onOk}
      cancelButtonProps={{ style: { display: 'none' } }}
      footer={[
        <Button type="primary" key="2" onClick={onOk}>
          OK
        </Button>,
      ]}
    >
      <div className="show-print" style={{ paddingLeft: '20px', paddingRight: '20px' }}>
        <div
          className="show-print-flex"
          style={{
            background: '#ebebeb',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            padding: '10px',
          }}
        >
          {/* <img src={`/images/evine-logo.png`} style={{ width: '50px' }} alt="logo" /> */}
          <Title level={3} style={{ padding: '0 10px' }}>
            Recording Result
          </Title>
        </div>
        <div
          className="show-print-flex"
          style={{
            background: '#ebebeb',
            marginBottom: '20px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            width: '100%',
            padding: '10px',
          }}
        >
          <Title level={3} style={{ padding: '10px' }}>
            Student Name: {data?.currentUserName}
          </Title>
          <Title level={3} style={{ padding: '10px', margin: 0 }}>
            Class: {data?.className}
          </Title>
        </div>
        <Title level={4} className="show-print" style={{ padding: '0 10px', marginTop: 0 }}>
          Recording
        </Title>
        <div style={{ padding: 20, lineHeight: '60px' }} dangerouslySetInnerHTML={{ __html: data?.recording_data }} />
        <div style={{ display: 'flex', justifyContent: 'space-between', borderTop: '1px solid #aaa' }}>
          <span>accuracy: {data?.accuracy ? data?.accuracy : '-'}</span>
          <span>wpm: {data?.wpm ? data.wpm : 0}</span>
        </div>
      </div>
      <div className="hide-print" dangerouslySetInnerHTML={{ __html: data?.recording_data }} />
      <div className="hide-print" style={{ display: 'flex', justifyContent: 'space-between', borderTop: '1px solid #aaa' }}>
        <span>accuracy: {data?.accuracy ? data?.accuracy : '-'}</span>
        <span>wpm: {data?.wpm ? data.wpm : 0}</span>
      </div>
    </Modal>
  );
};

